import { render, staticRenderFns } from "./LogoBrand.vue?vue&type=template&id=0ac56167&scoped=true&"
import script from "./LogoBrand.vue?vue&type=script&lang=js&"
export * from "./LogoBrand.vue?vue&type=script&lang=js&"
import style0 from "./LogoBrand.vue?vue&type=style&index=0&id=0ac56167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac56167",
  null
  
)

export default component.exports